export default interface Headers {
    [key: string]: any;
}
